import type { ReactNode } from "react";

import { Flex } from "@chakra-ui/react";
import { getTrackingId } from "../../helpers/getTrackingId";
import { Logo } from "@euka-mfes/bark";

interface PropTypes {
  children: ReactNode;
  backgroundImg: string;
  trackingId: string;
}

const LoginLayout = ({ children, backgroundImg, trackingId }: PropTypes) => {
  return (
    <Flex minHeight="100vh">
      <Flex
        flexDirection="column"
        padding={8}
        backgroundColor="canvas.colourful"
        display={{ base: "none", md: "flex" }}
        backgroundImage={`url(${backgroundImg})`}
        backgroundRepeat="no-repeat"
        backgroundPosition="center"
        backgroundSize={{ base: "70%", lg: "60%" }}
        width="50%"
        data-tracking-id={getTrackingId([trackingId], "page-image")}
      >
        <Logo
          variant="inline"
          alt="Euka logo"
          size="xl"
          isDarkMint
          data-tracking-id={getTrackingId([trackingId], "logo-desktop")}
        />
      </Flex>
      <Flex
        direction={{ base: "column", md: "row" }}
        backgroundRepeat="no-repeat"
        width={{ base: "100%", md: "50%" }}
      >
        <Flex
          p="12px 16px"
          backgroundColor="canvas.colourful"
          display={{ base: "flex", md: "none" }}
        >
          <Logo
            variant="inline"
            alt="Euka logo"
            size="xl"
            isDarkMint
            data-tracking-id={getTrackingId([trackingId], "logo-mobile")}
          />
        </Flex>
        <Flex
          flex={1}
          direction="column"
          justify={{ md: "center" }}
          align="center"
          backgroundColor="canvas.parchment"
          px={{ base: 4, md: 8, lg: 16 }}
          pt={{ base: 8 }}
        >
          {children}
        </Flex>
      </Flex>
    </Flex>
  );
};

export default LoginLayout;
